import angular from 'angular';
import template from './charsCountDownComponent.jade';

export class CharsCountdownController {
  /* @ngInject */
  constructor() {}

  get available () {
    if(!this.string) {
      return this.maxCharsNumber;
    }
    else {
      return this.maxCharsNumber - this.string.length > 0 ? this.maxCharsNumber - this.string.length : 0;
    }
  }
}

export let CharsCountdownComponent = {
  template: (($element, $attrs) => template),
  controller: CharsCountdownController,
  restrict: 'E',
  controllerAs: 'vm',
  bindings: {
    maxCharsNumber: '@',
    string: '='
  }
};

export default angular.module('app.common.charsCountdown', [])
  .component('charsCountdown', CharsCountdownComponent)


/** WEBPACK FOOTER **
 ** ./src/common/miniComponents/charsCountDownComponent.js
 **/